// extracted by extract-css-chunks-webpack-plugin
module.exports = {"layout":"_2pYILU","title":"_294IY7","text":"_12mW8q"};